import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  icon: {
    marginRight: 8,
    alignSelf: 'flex-end',
  },
  title: {
    height: 18,
    width: 161,
  },
  desc1: {
    marginTop: 16,
    width: 282.6,
    height: 15,
  },
  desc2: {
    marginTop: 8,
    width: 251.83,
    height: 15,
  },
  btn: {
    marginTop: 26,
    height: 30,
    width: '100%',
    borderRadius: 6,
  },
});
